import FooterList from './FooterList'
import FooterInfoStrip from './FooterInfoStrip'

const Footer = ({ columns = [] }) => (
    <div className="footer">
        <div className="container-fluid footer-container">
            <div className="row footer-row">
                <div className="col-sm-1" />
                <div className="col-sm-11">
                    <div className="row">
                        {columns.map((column, index) => (
                            <FooterList key={index} {...column} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
        <FooterInfoStrip />
    </div>
)

export default Footer
